import { useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../App';

const useFetchData = ({ endpoint, setter, errorSetter, transformFn }) => {
  const fetchData = useCallback(() => {
    axios.get(`${API_BASE_URL}${endpoint}`)
      .then((res) => {
        const data = transformFn ? transformFn(res.data) : res.data;
        setter(data);
      })
      .catch((err) => {
        console.error(`Fehler beim Abrufen von ${endpoint}:`, err);
        if (errorSetter) errorSetter(`Fehler beim Laden: ${endpoint}`);
      });
  }, [endpoint, setter, errorSetter, transformFn]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return fetchData;
};

export default useFetchData;